module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e2617"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c6_r1#d6e1",
      "id": "d7e1"
    }
  }, [_c('i', [_vm._v("Pennsylvania Dutch "), _c('br'), _vm._v(" Glossary")])])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2697"
    }
  }, [_c('i', [_vm._v("aamen")]), _vm._v("—amen")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2747"
    }
  }, [_c('i', [_vm._v("ach")]), _vm._v("—oh")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2797"
    }
  }, [_c('i', [_vm._v("aenti")]), _vm._v("—aunt")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2847"
    }
  }, [_c('i', [_vm._v("bruder—")]), _vm._v("brother")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2907"
    }
  }, [_c('i', [_vm._v("The Budget")]), _vm._v("—a weekly newspaper serving Amish and Mennonite communities everywhere")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2987"
    }
  }, [_c('i', [_vm._v("daadi")]), _vm._v("—grandfather")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e3037"
    }
  }, [_c('i', [_vm._v("daed")]), _vm._v("—dad")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e3097"
    }
  }, [_c('i', [_vm._v("danki")]), _vm._v("—thanks")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e3147"
    }
  }, [_c('i', [_vm._v("dochder")]), _vm._v("—daughter")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e3197"
    }
  }, [_c('i', [_vm._v("dumm")]), _vm._v("—dumb")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e3247"
    }
  }, [_c('i', [_vm._v("dummkopp")]), _vm._v("—dummy")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e3307"
    }
  }, [_c('i', [_vm._v("Englisch")]), _vm._v("—a non-Amish person")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e3357"
    }
  }, [_c('i', [_vm._v("fraa")]), _vm._v("—wife")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e3407"
    }
  }, [_c('i', [_vm._v("gut")]), _vm._v("—good")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e3467"
    }
  }, [_c('i', [_vm._v("guder mariye")]), _vm._v("—good morning")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e3517"
    }
  }, [_c('i', [_vm._v("hatt")]), _vm._v("—hard")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e3567"
    }
  }, [_c('i', [_vm._v("haus")]), _vm._v("—house")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e3617"
    }
  }, [_c('i', [_vm._v("kapp")]), _vm._v("—prayer covering or cap")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e3728"
    }
  }, [_c('i', [_vm._v("kinner")]), _vm._v("—children or grandchildren")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e3778"
    }
  }, [_c('i', [_vm._v("kumme esse")]), _vm._v("—come eat")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e3828"
    }
  }, [_c('i', [_vm._v("lieb")]), _vm._v("—love")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e3878"
    }
  }, [_c('i', [_vm._v("maedel")]), _vm._v("—girl")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e3938"
    }
  }, [_c('i', [_vm._v("mamm")]), _vm._v("—mom")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e3988"
    }
  }, [_c('i', [_vm._v("mammi")]), _vm._v("—grandmother")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e4038"
    }
  }, [_c('i', [_vm._v("mei")]), _vm._v("—my")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e4088"
    }
  }, [_c('i', [_vm._v("mudder")]), _vm._v("—mother")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e4148"
    }
  }, [_c('i', [_vm._v("nee")]), _vm._v("—no")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e4198"
    }
  }, [_c('i', [_vm._v("onkel")]), _vm._v("—uncle")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e4248"
    }
  }, [_c('i', [_vm._v("Ordnung")]), _vm._v("—the written and unwritten rules of the Amish; the understood behavior by which the Amish are expected to live, passed down from generation to generation. Most Amish know the rules by heart.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e4418"
    }
  }, [_vm._v("Pennsylvania "), _c('i', [_vm._v("Deitsch")]), _vm._v("—Pennsylvania German, the language most commonly used by the Amish")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e4528"
    }
  }, [_c('i', [_vm._v("rumschpringe")]), _vm._v("—running-around period when a teenager turns sixteen years old")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e4608"
    }
  }, [_c('i', [_vm._v("schee beh")]), _vm._v("—nice legs")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e4668"
    }
  }, [_c('i', [_vm._v("sohn")]), _vm._v("—son")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e4718"
    }
  }, [_c('i', [_vm._v("Wie bischt?")]), _vm._v("—How are you?")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e4788"
    }
  }, [_c('i', [_vm._v("ya")]), _vm._v("—yes")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b91c95dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wise_9781401685553_epub_c6.5_r1.vue
// module id = 75
// module chunks = 0